import { useEffect, useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";

const useGetUserRules = ({ onError }) => {
  const [userRules, setUserRules] = useState();
  const { isLoading, setIsLoading } = useApiStatus({ isLoading: true });

  const productService = new GetUserInfoService();

  const loadUserRules = async () => {
    try {
      setIsLoading(true);
      const resRating = await productService.getUserRules(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (resRating.messageCode !== 200001) {
        onError(resRating.messageCode);
        if (resRating.messageCode === 500000) console.log(resRating);
      } else {
        setUserRules(resRating.result);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadUserRules();
    return () => setUserRules(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    userRules,
    isLoading,
  };
};

export default useGetUserRules;
